import { __assign } from "tslib";
import { Icon } from '@chakra-ui/react';
import React from 'react';
export function CircledMinusIcon(props) {
    return (React.createElement(Icon, __assign({ viewBox: "0 0 50 50", width: "50", height: "50", fill: "rgb(171, 231, 255)", stroke: "black" }, props),
        React.createElement("circle", { stroke: "none", cx: "25", cy: "25", r: "25" }),
        React.createElement("path", { fill: "none", strokeWidth: "5", d: "M10 25h30" })));
}
